import React from 'react';

/** Bloc « shimmer » (squelette de chargement animé). Dimensions libres ; l'animation est coupée si l'utilisateur la réduit. */
export const ShimmerBlock = ({ width = '100%', height = 14, radius = 6, className = '', style = {} }) => (
    <span
        className={`shimmer ${className}`}
        style={{ display: 'inline-block', width, height, borderRadius: radius, ...style }}
        aria-hidden="true"
    />
);

/** Lignes « libellé à gauche, valeur à droite » (cartes de statistiques). */
export const ShimmerRows = ({ rows = 4, label }) => (
    <div className="shimmer-rows" role="status" aria-live="polite" aria-label={label}>
        {Array.from({ length: rows }).map((_, index) => (
            <div className="shimmer-rows__row" key={index}>
                <ShimmerBlock width={`${38 + ((index * 11) % 22)}%`} />
                <ShimmerBlock width={56} height={16} />
            </div>
        ))}
    </div>
);

/** Lignes de tableau (photo ronde + colonnes). */
export const ShimmerTableRows = ({ rows = 4, columns = 5, avatar = true }) => (
    <>
        {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex} className="shimmer-table-row" aria-hidden="true">
                {Array.from({ length: columns }).map((__, colIndex) => (
                    <td key={colIndex}>
                        {avatar && colIndex === 0
                            ? <ShimmerBlock width={35} height={35} radius="50%" />
                            : <ShimmerBlock width={`${50 + ((rowIndex + colIndex) * 13) % 40}%`} />}
                    </td>
                ))}
            </tr>
        ))}
    </>
);

/** Zone de graphique : barres de hauteurs variées. */
export const ShimmerChart = ({ height = 260, label }) => (
    <div className="shimmer-chart" style={{ height }} role="status" aria-live="polite" aria-label={label}>
        {[55, 80, 40, 90, 65, 75, 50, 85].map((value, index) => (
            <ShimmerBlock key={index} width="100%" height={`${value}%`} radius={6} />
        ))}
    </div>
);
